import React, { useState } from "react";

import ContentRewardsModal from "@components/content-rewards-modal/content-rewads-modal";
import MainModal from "@components/modal/main-modal";

import { rewardsModalContent } from "@helpers/helpers";
import { RewardEnum } from "@typings/global.types";

type WrapperHelperModalsPropsType = {
  modalType: number | null;
  closeModalHandler: () => void;
  onEnter?: () => void;
  onExit?: () => void;
  queueModal: number;
};

function WrapperRewardsModals({
  modalType,
  closeModalHandler,
  onEnter,
  onExit,
  queueModal,
}: WrapperHelperModalsPropsType) {
  const getModalContent = (modalType: RewardEnum | null) => {
    if (modalType === null) return null;

    const content = rewardsModalContent[modalType];
    if (!content) return null;

    return (
      <ContentRewardsModal
        heading={content.heading}
        description={content.text}
        nameImg={content.nameImg}
        onClick={closeModalHandler}
        queueModal={queueModal}
      />
    );
  };

  const modalContent = getModalContent(modalType);

  const closeHandler = () => {
    closeModalHandler();
  };

  if (!modalContent) {
    return null;
  }

  return (
    <MainModal
      show={!!modalType}
      onClick={closeHandler}
      showCloseBtn
      onEnter={onEnter}
      onExit={onExit}
      isRewardModal
    >
      {modalContent}
    </MainModal>
  );
}

export default WrapperRewardsModals;
